import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/oz-leasing/banner_back.webp";
import { Link } from "gatsby";

function Banner() {
  return (
    <section
      className="banner_h100 smartid_banner "
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1 style={{ color: "#fff" }}>Oz Leasing web development</h1>
            <p style={{ color: "#fff" }}>
              Our team of qualified and experienced web designers and developers
              have an innovative approach to implement cutting-edge technologies
              to create highly functional, secure, and scalable websites with
              high ROI.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Get Inspired
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
